// extracted by mini-css-extract-plugin
export default {"card":"ProfessionSurveyCard_card__Wsycl","card__title":"ProfessionSurveyCard_card__title__6goOr","selected_text":"ProfessionSurveyCard_selected_text__l1hmv"};